
export const IconHome = ({
                             color = 'currentColor',
                             size = 12,
                             className = '',
                             ...props
                         }) =>{


    return <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        style={{flexShrink: 0}}
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
    >
        <rect x={5} y={3} width={14} height={18} rx={2} fill="#f8fafc" stroke="#94a3b8" strokeWidth={1.5}/>
        <path d="M3 8L12 2L21 8" stroke="#94a3b8" strokeWidth={1.5} strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M10 21v-5h4v5" stroke="#dc2626" strokeWidth={1.5} strokeLinecap="round"
              strokeLinejoin="round"/>
    </svg>
}